// extracted by mini-css-extract-plugin
export default {"appcontents":"app_appcontents__4q+Jj","guide":"app_guide__z2K4z"};